<div
  class="relative isolate inline-flex items-center rounded-full bg-shikenso-purple-base-10 p-1"
  role="group"
  [attr.aria-busy]="loading()"
>
  <span
    #thumb
    aria-hidden="true"
    class="absolute top-1 bottom-1 left-0 rounded-full bg-shikenso-base-white opacity-0 shadow-[0_1px_4px_rgba(31,2,36,0.12)] transition-[transform,width] ease-out motion-reduce:transition-none"
    [style.transition-duration.ms]="thumbSlideMs"
  ></span>

  @for (option of options(); track option.value) {
    <!-- z-[1], not DOM order, keeps labels above the thumb: iOS Safari/Chrome painted the thumb over the selected label. -->
    <button
      #segment
      type="button"
      class="relative z-[1] flex h-8 items-center gap-2 rounded-full px-4 text-sm text-shikenso-purple-base"
      [class.invisible]="loading()"
      [class.cursor-not-allowed]="option.disabled"
      [class.opacity-50]="option.disabled"
      [attr.aria-pressed]="option.value === selectedValue()"
      [attr.aria-disabled]="option.disabled || null"
      [matTooltip]="option.tooltip ?? '' | translate"
      [matTooltipDisabled]="!option.tooltip"
      (click)="!option.disabled && select(option.value)"
    >
      @if (option.icon) {
        <app-icon alt="" [src]="option.icon" [size]="16" />
      }
      <span>{{ option.label | translate }}</span>
      @if (option.count !== undefined && option.count !== null) {
        <span class="text-shikenso-purple-base-60">{{ option.count }}</span>
      }
    </button>
  }

  @if (loading()) {
    <ngx-skeleton-loader
      class="absolute inset-0 flex"
      [theme]="{ height: '100%', width: '100%', margin: '0', 'border-radius': '100vw' }"
    />
  }
</div>
